import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getProgressReport ({rootState}, _id) {
      return api.getProgressReport(rootState.project.current._id, _id)
    },
    async download ({rootState}, progressReport) {
      const result = await api.downloadProgressReport(rootState.project.current._id, [progressReport._id])
      require('downloadjs')(result, `${new Date(progressReport.createdAt).getFullYear()}-${new Date(progressReport.createdAt).getMonth() + 1}-${new Date(progressReport.createdAt).getDate()}進度報告.xlsx`)
    },
    async batchDownload ({rootState}, ids) {
      const result = await api.downloadProgressReport(rootState.project.current._id, ids)
      require('downloadjs')(result, `進度報告.${ids.length === 1 ? 'xlsx' : 'zip'}`)
    },
    async delete ({rootState}, _id) {
      await api.deleteProgressReport(rootState.project.current._id, _id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/progressReport.js